import LegalLayout from '@/components/LegalLayout'

export function MentionsLegales() {
  return (
    <LegalLayout title="Mentions légales">
      <p><strong>Éditeur du site :</strong> NEXACO Sàrl</p>
      <p><strong>Adresse :</strong> Suisse romande</p>
      <p><strong>Téléphone :</strong> +41 22 518 00 00</p>
      <p><strong>Email :</strong> contact@nexaco.ch</p>
      <p><strong>Hébergeur :</strong> Lumi</p>
      <h2 className="text-xl font-bold text-navy-700 mt-8">Propriété intellectuelle</h2>
      <p>L'ensemble du contenu de ce site (textes, images, logos) est protégé par le droit suisse et international de la propriété intellectuelle. Toute reproduction est interdite sans autorisation préalable.</p>
      <h2 className="text-xl font-bold text-navy-700 mt-8">Responsabilité</h2>
      <p>Les informations présentes sur le site sont fournies à titre indicatif. Nous nous efforçons de garantir leur exactitude mais ne pouvons être tenus responsables d'éventuelles erreurs ou omissions.</p>
    </LegalLayout>
  )
}

export function Confidentialite() {
  return (
    <LegalLayout title="Politique de confidentialité">
      <p>Nous attachons une grande importance à la protection de vos données personnelles, conformément à la LPD suisse et au RGPD.</p>
      <h2 className="text-xl font-bold text-navy-700 mt-8">Données collectées</h2>
      <p>Nous collectons uniquement les données nécessaires au traitement de votre demande : nom, téléphone, email, type de problème.</p>
      <h2 className="text-xl font-bold text-navy-700 mt-8">Utilisation des données</h2>
      <p>Vos données sont utilisées exclusivement pour vous contacter, planifier l'intervention et établir un devis. Elles ne sont jamais vendues à des tiers.</p>
      <h2 className="text-xl font-bold text-navy-700 mt-8">Vos droits</h2>
      <p>Vous disposez d'un droit d'accès, de rectification et de suppression de vos données. Pour exercer ces droits, contactez-nous à contact@nexaco.ch.</p>
      <h2 className="text-xl font-bold text-navy-700 mt-8">Cookies</h2>
      <p>Le site utilise uniquement des cookies techniques nécessaires au bon fonctionnement et, le cas échéant, des cookies de mesure d'audience anonymes.</p>
    </LegalLayout>
  )
}

export function CGV() {
  return (
    <LegalLayout title="Conditions générales">
      <h2 className="text-xl font-bold text-navy-700">Objet</h2>
      <p>Les présentes conditions régissent les prestations de plomberie, dépannage et installation sanitaire fournies par NEXACO Sàrl.</p>
      <h2 className="text-xl font-bold text-navy-700 mt-8">Devis et tarifs</h2>
      <p>Tout devis est gratuit et sans engagement. Les tarifs sont annoncés avant intervention. Aucun frais supplémentaire n'est facturé sans accord préalable du client.</p>
      <h2 className="text-xl font-bold text-navy-700 mt-8">Intervention d'urgence</h2>
      <p>En cas d'intervention d'urgence (nuit, week-end, jours fériés), des majorations peuvent s'appliquer et sont communiquées au client avant le déplacement.</p>
      <h2 className="text-xl font-bold text-navy-700 mt-8">Garantie</h2>
      <p>Les travaux et fournitures sont garantis selon les normes en vigueur. La garantie ne couvre pas les dégradations dues à un usage anormal.</p>
      <h2 className="text-xl font-bold text-navy-700 mt-8">Paiement</h2>
      <p>Le paiement s'effectue à réception de facture, par virement bancaire ou autre moyen convenu.</p>
      <h2 className="text-xl font-bold text-navy-700 mt-8">Droit applicable</h2>
      <p>Les présentes conditions sont régies par le droit suisse. Tout litige sera soumis aux tribunaux compétents du canton de domicile du prestataire.</p>
    </LegalLayout>
  )
}
